import dataApi from '../'

export default {

  /**
   * Get till overview
   */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/till/overview',
      params: params
    })
  },
  getTillsForOrganization (organizationUuid) {
    return dataApi.request({
      method: 'get',
      url: 'ui/till/search/organization/' + organizationUuid
    })
  },
  getTillsForUnit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/till/search/unit/' + params.uuid,
      params: params.params
    })
  },
  getTill (tillUuid) {
    return dataApi.request({
      method: 'get',
      url: 'ui/till/get/' + tillUuid
    })
  },
  /**
   * Delete till and disconnect from attached units
   */
  deleteDelete (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/till/delete',
      params: params
    })
  },

  /**
   * Add till
   */
  postAdd (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/till/add',
      body: params
    })
  },

  /**
   * Edit till
   */
  putEdit (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/till/edit',
      body: params
    })
  },

  /**
   * Get units which will be disconnected
   */
  getUnitsToBeDisconnected (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/till/delete',
      body: params
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/endpoints/till.js